module.exports = __webpack_public_path__ + "static/HKGrotesk-Bold-e33516e0eebee20f8857204b3ceb1281.ttf";